export default {
  /**
   * 获取链接参数
   * @param url 链接
   * @param name 参数名称
   */
  getUrlParameter(url: string, name: string) {
    const regexSearch = '[\\?&#]' + name + '=([^&#]*)';
    const regex = new RegExp(regexSearch);
    const results = regex.exec(url);
    return results ? window.decodeURIComponent(results[1]) : '';
  }
};
